<template>
  <div class="bg">
    <div class="el">
      <div class="info">
        <img id="logo" src="assets/images/Olokun Logo-Final-01.png" alt="">
        <!-- <h1>OLOKUN</h1> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style src="@/assets/styles/BlackAndWhte.css"></style>